import { FC } from 'react';
import { motion } from 'framer-motion';

import AureusOxLogo from '../../../assets/aureus-ox-logo-cmyk-design-300ppi-02.png';

const AUREUS = {
  green: '#6FC2AE',
  blue: '#609EBD',
  navy: '#01263D',
  purple: '#4643D3'
};

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7 } }
};

/**
 * Landing attribution: Oxen Flow product is built & curated by Aureus Ox.
 * Secondary brand credit — keeps Oxen Flow primary on this domain.
 */
const BuiltBySection: FC = () => {
  return (
    <motion.section
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      variants={fadeInUp}
      className="py-24 relative overflow-hidden"
      style={{ background: 'rgba(1, 38, 61, 0.35)' }}
    >
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute top-1/3 -left-16 w-72 h-72 rounded-full blur-3xl opacity-25"
          style={{ background: AUREUS.blue }}
        />
        <div
          className="absolute bottom-1/4 -right-16 w-80 h-80 rounded-full blur-3xl opacity-20"
          style={{ background: AUREUS.green }}
        />
      </div>

      <div className="relative mx-auto max-w-3xl px-6 text-center">
        <p
          className="text-xs uppercase tracking-[0.25em] mb-5 font-medium"
          style={{ color: AUREUS.blue }}
        >
          Curated by
        </p>

        <h2 className="text-3xl md:text-4xl font-black mb-6">
          <span style={{ color: AUREUS.green }}>Aureus Ox</span>
        </h2>

        <p className="text-lg md:text-xl opacity-80 mb-10 max-w-2xl mx-auto leading-relaxed">
          Oxen Flow is designed and maintained by Aureus Ox — the same team
          running production Flare &amp; XRPL infrastructure. Product UX on top
          of operator-grade systems.
        </p>

        <a
          href="https://aureusox.com"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex flex-col items-center gap-4 group"
        >
          <div className="relative">
            <div
              className="absolute -inset-4 rounded-2xl blur opacity-30 group-hover:opacity-50 transition-opacity"
              style={{
                background: `linear-gradient(90deg, ${AUREUS.green}, ${AUREUS.blue}, ${AUREUS.purple})`
              }}
            />
            <img
              src={AureusOxLogo}
              alt="Aureus Ox"
              className="relative w-44 md:w-52"
            />
          </div>
          <span
            className="text-base font-medium group-hover:underline underline-offset-4 transition-all"
            style={{ color: AUREUS.green }}
          >
            Visit aureusox.com →
          </span>
        </a>
      </div>
    </motion.section>
  );
};

export default BuiltBySection;
